import LabCategoryInfo from './LabCategoryInfo';

export default LabCategoryInfo;
